import React from "react";

import { formatKST } from "../../utils/dateUtils";
import {
  deviceTypeBadgeClass,
  deviceTypeText,
  getBatteryText,
  getGpsText,
  getHeartRateText,
  getOwnerText,
  getSafeLastSeenForDisplay,
  getStreamStatusText,
  normalizeDeviceTypeValue,
} from "../../utils/deviceUtils";
import {
  statusBadgeClass,
  statusLabelText,
} from "../../utils/statusUtils";

export default function DeviceMobileList({ loading, devices }) {
  return (
    <div className="space-y-3 lg:hidden">
      {!loading && devices.length === 0 ? (
        <div className="rounded-[22px] border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 dark:border-white/10 dark:bg-[#0F172A] dark:text-gray-400">
          표시할 장비가 없습니다.
        </div>
      ) : (
        devices.map((item) => (
          <div
            key={item.rowKey}
            className="rounded-[22px] border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-[#0F172A]"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="break-words text-base font-bold text-gray-900 dark:text-white">
                  {item.name || "-"}
                </div>
                <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  ID: {item.deviceId || "-"}
                </div>
              </div>

              <span
                className={`inline-flex shrink-0 whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${statusBadgeClass(
                  item.status
                )}`}
              >
                {statusLabelText(item.status)}
              </span>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span
                className={`inline-flex whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${deviceTypeBadgeClass(
                  item.deviceType
                )}`}
              >
                {deviceTypeText(item.deviceType)}
              </span>

              {(normalizeDeviceTypeValue(item.deviceType) === "MINTCAM" ||
                normalizeDeviceTypeValue(item.deviceType) ===
                  "MOBILE_CCTV") && (
                <span className="inline-flex whitespace-nowrap rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700 dark:bg-white/10 dark:text-gray-300">
                  {getStreamStatusText(item)}
                </span>
              )}
            </div>

            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  사용자/담당자
                </div>
                <div className="mt-1 break-words text-sm text-gray-800 dark:text-gray-100">
                  {getOwnerText(item)}
                </div>
              </div>

              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  마지막 통신시간
                </div>
                <div className="mt-1 break-words text-sm text-gray-800 dark:text-gray-100">
                  {formatKST(getSafeLastSeenForDisplay(item))}
                </div>
              </div>

              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  배터리
                </div>
                <div className="mt-1 text-sm text-gray-800 dark:text-gray-100">
                  {getBatteryText(item.battery, item.status)}
                </div>
              </div>

              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  심박수
                </div>
                <div className="mt-1 text-sm text-gray-800 dark:text-gray-100">
                  {getHeartRateText(item.heartRate, item.status)}
                </div>
              </div>

              <div className="sm:col-span-2">
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  GPS
                </div>
                <div className="mt-1 break-words text-sm text-gray-700 dark:text-gray-200">
                  {getGpsText(item)}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}